"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createEmptyTarget = exports.createEmptyFilter = exports.EverbridgePassportHeaderDefault = exports.EverbridgePassportDefault = exports.EverbridgeMappingDefault = void 0;
var _uuid = require("uuid");
var _common = require("../common");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var createEmptyFilter = exports.createEmptyFilter = function createEmptyFilter() {
  return {
    key: "",
    value: ""
  };
};
var createEmptyTarget = exports.createEmptyTarget = function createEmptyTarget() {
  return {
    layoutId: _objectSpread({}, _common.STRINGID_NOT_SET),
    canvases: []
  };
};
var EverbridgePassportHeaderDefault = exports.EverbridgePassportHeaderDefault = function EverbridgePassportHeaderDefault() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    name: "",
    description: "",
    organizationId: "",
    filters: [],
    auth: {
      type: "apiKey",
      apiKeyValue: "",
      username: "",
      password: "",
      basicToken: ""
    }
  };
};
var EverbridgePassportDefault = exports.EverbridgePassportDefault = function EverbridgePassportDefault() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    name: "",
    description: "",
    isConnected: false,
    organizationId: "",
    auth: {
      type: "apiKey",
      hasCredentialsConfigured: false
    },
    filters: [],
    state: {
      processedIncidents: 0,
      lastPollTime: null,
      lastIncidentTime: null
    }
  };
};
var EverbridgeMappingDefault = exports.EverbridgeMappingDefault = function EverbridgeMappingDefault(passportId) {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    passportId: passportId !== null && passportId !== void 0 ? passportId : {
      value: ""
    },
    name: "",
    titles: [],
    filters: [],
    target: createEmptyTarget(),
    enabled: true,
    createdTime: new Date().getTime() / 1000,
    updatedTime: new Date().getTime() / 1000
  };
};